module.exports = __webpack_public_path__ + "img/img5.d22a97ae.png";